import React from 'react';
import RegistrationPic from "./registration.jpg";

function Registration() {
    return (
        <div className="">
            {/* Image Section */}
            <div className="relative mb-12">
                <img
                    className="h-96 w-full object-cover object-center rounded-b-2xl shadow-2xl"
                    src={RegistrationPic}
                    alt="A beautiful landscape"
                    loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-b-2xl"></div>
                <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center w-full px-4">
                    <h1
                        className="text-4xl md:text-5xl font-extrabold text-white mb-3 text-center tracking-tight shadow-sm"
                    >
                        Approved Fees
                    </h1>
                </div>
            </div>

            {/* Becoming a Member Section */}
            <div className="flex flex-col justify-center items-center my-8 md:my-14 mx-auto container px-4 lg:px-8">
                <div className="font-black leading-4 text-gray-800 uppercase dark:text-white text-center">
                    <h4 className='font-black'>LSB SERVICES</h4>
                    <p className='font-medium'>PAYMENTS TO THE BOARD THROUGH E-CITIZEN via MPESA PAYBILL</p>
                </div>

                {/* Table Section */}
                <div className="mt-3">
                    <table className="table-auto border-collapse border border-gray-300">
                        <thead className="bg-gray-600 text-white">
                            <tr>
                                <th className="px-4 py-2">Service</th>
                                <th className="px-4 py-2">Business No.</th>
                                <th className="px-4 py-2">Account No.</th>
                                <th className="px-4 py-2">Service Code</th>
                                <th className="px-4 py-2">Amount (Ksh.)</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Annual Renewal of Practicing License – Licensed Surveyor</td>
                                <td className="px-4 py-2 text-center">222222</td>
                                <td className="px-4 py-2 text-center">ARPL-<span className="text-red-500 font-bold">XXX</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">XXX</span> denotes License Number</td>
                                <td className="px-4 py-2 text-center">15,000.00</td>
                            </tr>

                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Annual Renewal Fees – Approved Assistant</td>
                                <td className="px-4 py-2 text-center">"</td>
                                <td className="px-4 py-2 text-center">ANFA-<span className="text-red-500 font-bold">XXX</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">XXX</span> denotes License Number</td>
                                <td className="px-4 py-2 text-center">5,000.00</td>
                            </tr>

                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Application for Kenya Survey License Registration</td>
                                <td className="px-4 py-2 text-center">"</td>
                                <td className="px-4 py-2 text-center">AKSL-<span className="text-red-500 font-bold">YYY</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">YYY</span> denotes Name of Applicant</td>
                                <td className="px-4 py-2 text-center">15,000.00</td>
                            </tr>

                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Application for Registration of Approved Assistant</td>
                                <td className="px-4 py-2 text-center">"</td>
                                <td className="px-4 py-2 text-center">ARAA-<span className="text-red-500 font-bold">XXX</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">XXX</span> denotes License Number</td>
                                <td className="px-4 py-2 text-center">5,000.00</td>
                            </tr>

                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Application for Land Law Examination</td>
                                <td className="px-4 py-2 text-center">"</td>
                                <td className="px-4 py-2 text-center">ALLE-<span className="text-red-500 font-bold">YYY</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">XXX</span> denotes Name of Applicant</td>
                                <td className="px-4 py-2 text-center">5,000.00</td>
                            </tr>

                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Issue of Identity Cards</td>
                                <td className="px-4 py-2 text-center">"</td>
                                <td className="px-4 py-2 text-center">ISDC-<span className="text-red-500 font-bold">XXX</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">XXX</span> denotes License Number</td>
                                <td className="px-4 py-2 text-center">3,000.00</td>
                            </tr>

                            <tr className="border-b border-gray-300">
                                <td className="px-4 py-2">Issue of Bound Land Law Papers</td>
                                <td className="px-4 py-2 text-center">"</td>
                                <td className="px-4 py-2 text-center">BLLP-<span className="text-red-500 font-bold">YYY</span></td>
                                <td className="px-4 py-2"><span className="text-red-500 font-bold">XXX</span> denotes Name of Applicant</td>
                                <td className="px-4 py-2 text-center">5,000.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Registration;